import { BorderGridContainer, GridBox, Hidden, Image } from '@ahmdigital/ui';
import { size } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import { determineProductIdFromBundles } from '../../utils/bundle';
import BundleChosenView from './components/bundle-chosen-view';
import NoBundleChosenView from './components/no-bundle-chosen-view';
import personaliseYourPriceImage from './images/personalise-your-price.svg';
import styles from './styles.module.sass';

const Container = styled.div<{ isVisible: boolean }>`
  bottom: -0.5rem;
  margin-top: -0.5rem;
  position: sticky;
  transition: transform 0.3s;
  transform: ${({ isVisible }) => (isVisible ? 'none' : 'translateY(100%)')};
  z-index: ${({ theme }) => theme.zIndices.footer};
`;

type JoinBarProps = {
  customer: {
    frequency: string;
  };
  effectiveDate?: string;
  isVisible?: boolean;
  prices?: {};
  selectedBundles: string[];
};

const JoinBar = ({ customer, effectiveDate, isVisible, prices, selectedBundles }: JoinBarProps) => {
  const isBundleChosen = size(selectedBundles) > 0;
  const productId = determineProductIdFromBundles(selectedBundles);

  return (
    // @ts-expect-error - Automatic, Please fix when editing this file
    <Container data-testid="join-bar" isVisible={isVisible}>
      <BorderGridContainer>
        <GridBox padding="1rem">
          <div className={styles.viewWrapper}>
            <Hidden xs sm>
              <Image
                className={styles.personaliseYourPrice}
                src={personaliseYourPriceImage.src}
                alt="Personalise Your Price"
                width="64px"
                height="48px"
              />
            </Hidden>
            {isBundleChosen ? (
              <BundleChosenView
                {...{
                  customer,
                  effectiveDate,
                  prices,
                  productId,
                }}
              />
            ) : (
              <NoBundleChosenView />
            )}
          </div>
        </GridBox>
      </BorderGridContainer>
    </Container>
  );
};

JoinBar.defaultProps = {
  effectiveDate: null,
  isVisible: false,
  prices: null,
};

export default JoinBar;
